// fetchFromApi.js 
import axios from 'axios';

export const BASE_URL = 'https://youtube-v31.p.rapidapi.com';

const options = {
  params: {
    maxResults: 50,
  },
  headers: {
    'X-RapidAPI-Key': process.env.REACT_APP_RAPID_API_KEY,
    'X-RapidAPI-Host': 'youtube-v31.p.rapidapi.com',
  },
};

export const fetchFromAPI = async (url, regionCode = 'GB', relevanceLanguage = 'en') => {
  const params = {
    ...options.params,
    regionCode,
    relevanceLanguage,
    safeSearch: 'strict', // strict safe search excludes videos that are restricted on other websites - remove this line to remove this
  };

  const { data } = await axios.get(`${BASE_URL}/${url}`, { ...options, params });

  return data;
};


// FetchFromApi.js